export const EVENTQ_REQUIRED_INVALID_MESSAGE = 'This field is required';

export function isEventqRequired(value: string): boolean {
  return value.trim().length > 0;
}
